export default {
  SET_RATE: "SET_RATE",
  RATE_ORDER: "RATE_ORDER",
  RATE_ORDER_SUCCESS: "RATE_ORDER_SUCCESS",
  RATE_ORDER_ERROR: "RATE_ORDER_ERROR",
  GET_SHIPPING_DETAILS: "GET_SHIPPING_DETAILS",
  GET_SHIPPING_DETAILS_SUCCESS: "GET_SHIPPING_DETAILS_SUCCESS",
  GET_SHIPPING_DETAILS_ERROR: "GET_SHIPPING_DETAILS_ERROR",
};
